import { bindActionCreators } from 'redux';

export function listBlogs(params, page) {
    return async (_dispatch, getState, { apiClient }) => {
        return await apiClient.listBlogs(params, page);
    };
}

export function retrieveBlogTagList() {
    return async (_dispatch, getState, { apiClient }) => {
        return await apiClient.retrieveBlogTagList();
    };
}

export function retrieveBlog(slug) {
    return async (_dispatch, getState, { apiClient }) => {
        return await apiClient.retrieveBlog(slug);
    };
}

export function createBlogActionCreator(dispatch) {
    return bindActionCreators({
        listBlogs,
    }, dispatch);
}